module.exports = __webpack_public_path__ + "img/edit.566dcd20.svg";